import { useLayoutEffect } from "react";

/**
 * core-react only enables dialog FocusScope (autoFocus / contain / restoreFocus)
 * when `onClose` is set. Pass this no-op so focus stays in the modal.
 * Pair with `howToClose={[]}` so X and scrim do not dismiss.
 * Escape still invokes `onClose`; a no-op swallows it.
 */
export function trapFocusWithoutDismiss(): void {
    // Intentionally empty. See file comment.
}

/**
 * core-react Modal's `useScrollLock` sets `body { position: fixed; max-width: 100vw }`
 * without `width` / `left`. A `position: fixed` body shrink-to-fits, so HUD chrome
 * centered with `left: 50%` (bottom nav) jumps to the side until the dialog closes.
 * Pin the body to the viewport for the lifetime of the GPU wizard.
 */
export function usePreserveBodyLayoutWhileModalOpen(enabled = true): void {
    useLayoutEffect(() => {
        if (!enabled) {
            return;
        }
        const { style } = document.body;
        const previousWidth = style.width;
        const previousLeft = style.left;
        const previousRight = style.right;
        style.width = "100%";
        style.left = "0px";
        style.right = "0px";
        return () => {
            style.width = previousWidth;
            style.left = previousLeft;
            style.right = previousRight;
        };
    }, [enabled]);
}
